import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card card-feat\"><div class=\"card-body\"><div class=\"row\"><div class=\"col\"><h1 class=\"h2 mb-3 text-center\"> Du har ingen aktiv privatlåneansökan </h1></div></div></div></div>", 1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 mb-3 text-center" }, "Dina förslag - Privatlån", -1)
const _hoisted_7 = { class: "table loan-table" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "status-category",
      scope: "col"
    }, "Status på ansökan"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "status-category",
      scope: "col"
    }, "Ansökt belopp"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "status-category",
      scope: "col"
    }, "Antal år")
  ])
], -1)
const _hoisted_9 = { class: "status-category-value" }
const _hoisted_10 = { class: "status-category-value" }
const _hoisted_11 = { class: "status-category-value" }
const _hoisted_12 = {
  key: 0,
  class: "ms-n5"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "Ändra ansökan", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "ms-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/icons/edit-icon.svg",
    alt: "Edit"
  })
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "row"
}
const _hoisted_17 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_18 = { class: "card card-feat" }
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, " Om du vill att vi försöker ändra det ansökta beloppet och/eller återbetalningstiden kan du skriva in de nya uppgifterna nedan: ", -1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-sm-6 mb-3" }
const _hoisted_23 = { class: "col-sm-6 mb-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary mt-3"
}, " ÄNDRA ANSÖKAN ", -1)
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "message-short" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Vi kommer hantera din ändring i den ordning den inkommit till oss under våra normala öppettider måndag-fredag. Vill du göra ytterligare ändringar kan du skicka ett ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("nytt meddelande")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" till oss. Vi kommer då se det nya meddelandet samtidigt som det automatiska meddelandet ovan. ")
const _hoisted_30 = { class: "container-nm" }
const _hoisted_31 = { class: "header-description" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "Tyvärr har vi inte kunnat hitta något lånealternativ. Det kan bero på flera saker. Du är välkommen att ta kontakt per telefon eller genom meddelandefunktionen om du vill veta mer just nu.  ", -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "Observera att din ansökan ännu inte är färdigbehandlad.  ", -1)
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 3 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", null, "Har du befintliga lån och krediter med högre räntor jämfört med de alternativ du har fått nedan? ", -1)
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 2,
  class: "row"
}
const _hoisted_43 = { class: "col-sm-12 col-sm-12 col-md-12 order-list" }
const _hoisted_44 = {
  key: 0,
  class: "col-sm-12 col-md-12 col-lg-4 priority-list"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Lånealternativen du ser sorteras enligt följande: ")
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "1) Lånebelopp.")
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", null, " Beloppen kan skilja sig åt om bankerna inte har godkänt hela beloppet du sökte. ", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "2) Effektiv ränta.")
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", null, "Högst upp betyder lägst kostnad.", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "3) Månadskostnad. ")
], -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", null, "Om den effektiva räntan är lika.", -1)
const _hoisted_53 = [
  _hoisted_45,
  _hoisted_46,
  _hoisted_47,
  _hoisted_48,
  _hoisted_49,
  _hoisted_50,
  _hoisted_51,
  _hoisted_52
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LoanOfferCard = _resolveComponent("LoanOfferCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.app || !_ctx.app.loanStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.app && _ctx.app.loanStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("table", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.loanStatusText), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.app.loanAmount ? _ctx.app.loanAmount.toLocaleString("se") : "") + " kr ", 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.app.paybackYears), 1)
              ])
            ])
          ]),
          (_ctx.app.loanStatus != 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("button", {
                  class: "btn primary-button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showchangeRequest = !_ctx.showchangeRequest))
                }, _hoisted_15)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showchangeRequest)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (!_ctx.changeRequestSubmitted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("form", {
                            class: "col",
                            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitChange && _ctx.submitChange(...args)), ["prevent"]))
                          }, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createVNode(_component_TextField, {
                                  label: "Nytt lånebelopp",
                                  modelValue: _ctx.changeRequestLoanAmount,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.changeRequestLoanAmount) = $event)),
                                  required: true,
                                  numbersOnly: false
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_SelectInput, {
                                  label: "Ny återbetalningstid",
                                  modelValue: _ctx.changeRequest.paybackYears,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.changeRequest.paybackYears) = $event)),
                                  options: [
                        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                        17, 18
                      ]
                                }, null, 8, ["modelValue"])
                              ])
                            ]),
                            _hoisted_24
                          ], 32)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.changeRequestSubmitted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createVNode(_component_router_link, { to: "/message/add" }, {
                          default: _withCtx(() => [
                            _hoisted_28
                          ]),
                          _: 1
                        }),
                        _hoisted_29
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              (_ctx.app.loanStatus === 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_32, " Din ansökan är färdigbehandlad och samtliga banker har återkommit med svar. Lånealternativ ser du nedan. "))
                : (_ctx.app.loanStatus === 2)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                      _hoisted_34,
                      (_ctx.headerExpandDone)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Du kommer även få ett mejl av oss med mer information inom kort."))
                        : _createCommentVNode("", true),
                      (!_ctx.headerExpandDone)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: "#",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.headerExpandDone = true), ["prevent"]))
                          }, "Läs mer"))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.app.loanStatus === 4)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                        _hoisted_37,
                        (_ctx.headerExpandTreatment)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Nedan kommer du se lånealternativen så snart vi får in dem från bankerna. Vår rekommendation är att du väntar på bankerna så att du får in fler alternativ. Inom en timme bör de flesta ha inkommit."))
                          : _createCommentVNode("", true),
                        (!_ctx.headerExpandTreatment)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: "#",
                              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.headerExpandTreatment = true), ["prevent"]))
                            }, "Läs mer"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
              (_ctx.app.loanStatus != 2 || _ctx.app.purpose != 5)
                ? (_openBlock(), _createElementBlock("p", _hoisted_39, [
                    _hoisted_40,
                    (_ctx.headerExpanded)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Du kan spara tusentals kronor genom att samla gamla lån och krediter in i det nya lånet. Klicka på den blåa knappen ovan för att ändra ansökningsbeloppet och/eller återbetalningstiden. Det är viktigt att du avstår från att göra låneansökningar under tiden som du väntar svar från oss då det kan leda till att långivarna drar tillbaka sina erbjudande."))
                      : _createCommentVNode("", true),
                    (!_ctx.headerExpanded)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: "#",
                          class: "url",
                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.headerExpanded = true), ["prevent"]))
                        }, "Läs mer"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.app && _ctx.app.loanStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedOffers, (offer) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "container-nm mb-3",
                key: offer.id
              }, [
                _createVNode(_component_LoanOfferCard, { offer: offer }, null, 8, ["offer"])
              ]))
            }), 128))
          ]),
          (_ctx.sortedOffers.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_53))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}